import actions from "./actions"
import mutations from "./mutations"
import getters from "./getters"
import { initialState } from "./state"

import Plan from "./Plan"
import Combo from "./Combo"
import Sva from "./Sva"

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  modules: {
    Plan,
    Combo,
    Sva
  }
}
